import { ITelemetryItem } from "@microsoft/applicationinsights-web";

import { getClaims } from "@/shared/hooks";
import { xCorrelationIdProvider } from "@/shared/hooks/useAuth/providers";

export const defaultTelemetryInitializer = (obj: ITelemetryItem): boolean | void => {
    const { data } = obj;
    const claims = getClaims();
    data["X-Correlation-ID"] = xCorrelationIdProvider.getXCorrelationId();

    if (claims) {
        data["OfficeId"] = claims.officeId;
    }
};
